module.exports = __webpack_public_path__ + "static/media/13 Se pa mig (ft Erik Lundin_eq 05-29.b0c3d982.mp3";